import { lightTheme, darkTheme } from '@controlrooms/design-tokens';

export type ResizablePanelTheme = {
  sidebarBg: string;
  dividerBg: string;
  dividerBgHover: string;
  mainBg: string;
  contentText: string;
};

export const resizablePanelTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      sidebarBg: theme.color.grid['select-inherited-stripe'],
      dividerBg: theme.color.surface[2],
      dividerBgHover: theme.color.surface[3],
      mainBg: theme.color.surface[4],
      contentText: theme.color.text.core['-emphasis'],
    },
  ]),
);

// Legacy exports for backward compatibility
export const resizablePanelDarkTheme: ResizablePanelTheme =
  resizablePanelTheme.dark as ResizablePanelTheme;
export const resizablePanelLightTheme: ResizablePanelTheme =
  resizablePanelTheme.light as ResizablePanelTheme;
